import Pane from 'components/Common/Pane'
import React from 'react'
import { rem } from 'polished'
import { OfferPackageOptionView } from 'selectors/offerPage/offerPageSelectors'
import ScrollAnchor from 'components/Common/ScrollAnchor'
import AccommodationRoomTile from 'components/AccommodationKit/AccommodationRoomTile'
import Divider from 'components/Luxkit/Divider'
import AccommodationPackageTile from 'components/AccommodationKit/AccommodationPackageTile'
import AccommodationPackageTileContentArea from 'components/AccommodationKit/AccommodationPackageTileContentArea'
import AccommodationPackageTilePricingArea from 'components/AccommodationKit/AccommodationPackageTilePricingArea'
import AccommodationPackageTileDetails from 'components/AccommodationKit/AccommodationPackageTileDetails'
import LargeContentToggle from 'components/Common/LargeContentToggle'
import AccommodationPackageTileInclusions from 'components/AccommodationKit/AccommodationPackageTileInclusions'
import AccommodationRoomTileDetails from 'components/AccommodationKit/AccommodationRoomTileDetails'
import AccommodationRoomTileImage from 'components/AccommodationKit/AccommodationRoomTileImage'
import { useOfferInclusions } from 'hooks/useOfferInclusions'
import InclusionsSection from '../FlashHotel/InclusionsSection'

interface Props {
  packageView: OfferPackageOptionView;
}

function LastMinutePackageOption(props: Props) {
  const {
    packageView,
  } = props

  const {
    package: pkg,
  } = packageView

  const { inclusions, bonusInclusions } = useOfferInclusions(pkg)
  const hasInclusions = bonusInclusions.length > 0 || inclusions.length > 0

  return (
    <Pane shadow="bottom-small" data-testid="package-option">
      <ScrollAnchor id={pkg.roomType.id} vOffset={rem(80)} />
      <AccommodationRoomTile roomPackage={pkg}>
        <AccommodationRoomTileImage
          roomPackage={pkg}
        />
        <AccommodationRoomTileDetails
          roomPackage={pkg}
        />
      </AccommodationRoomTile>
      <Divider kind="primary" />
      <AccommodationPackageTile>
        <AccommodationPackageTileContentArea>
          <AccommodationPackageTileDetails
            packageNumber={1}
            roomPackage={packageView.package}
          />
          <AccommodationPackageTileInclusions>
            <LargeContentToggle
              maxHeight={208}
              showMoreText="View more inclusions"
              showLessText="View less inclusions"
            >
              {hasInclusions && <InclusionsSection
                inclusions={inclusions}
                bonusInclusions={bonusInclusions}
              />}
            </LargeContentToggle>
          </AccommodationPackageTileInclusions>
        </AccommodationPackageTileContentArea>
        <AccommodationPackageTilePricingArea />
      </AccommodationPackageTile>
    </Pane>
  )
}

export default LastMinutePackageOption
